
import { useState } from "react";
import { Loader, Button, Input, Box } from "@launchmetrics/lm-ui";
import { SearchOutline } from '@launchmetrics/lm-icons';
import PropTypes from "prop-types";
import GenericDropdownMenu from "components/LM/common/GenericDropdownMenu";
import { useK2Loader } from 'hooks/useK2Loader';


const VOICE_OPTIONS = ["media", "brand", "influencer", "celebrity"];
const CHANNEL_OPTIONS = [
		"facebook",
		"instagram",
		"tiktok",
		"twitter",
		"youtube",
		"wechat_public",
		"bilibili",
		"douyin",
		"weibo",
		"xiaohongshu",
		"onlineMedia",
		"printMediaDmr"
	  ];

function VoiceSearchForm({ paginatedSearchLoading, onSubmit, onChange, loading, totalMatches, ...props }) {
	const {searchParams, countryMenu = [] } = props;
	const [currentTerm, setCurrentTerm] = useState(searchParams.term || '');
	const [selectedValues, setSelectedValues] = useState({
		type: searchParams.type ? searchParams.type.split(',') : [],
		channel: searchParams.channel ? searchParams.channel.split(',') : [],
		country: searchParams.country ? searchParams.country.split(',') : []
	});

	const [loadingCountries, countries] = useK2Loader('/countries');
	
	const onChangeForm = (ev) => {
		setCurrentTerm(ev.target.value);
	}

	const onDropdownChange = (name, values) => {
		setSelectedValues((prev) => ({ ...prev, [name]: values }));
	};

	const onSubmitClick = (ev) => {
		ev.preventDefault();
		onChange(currentTerm, selectedValues);
		onSubmit();
	}

	const showLoader = () => {
		if (loading || paginatedSearchLoading) {
			return <Loader styleProps={{ marginLeft: '10px'}}size={20} />;
		}
	}

	const voiceOptions = VOICE_OPTIONS.map(type => {
		return { value: type, label: type.charAt(0).toUpperCase() + type.slice(1) };
	});

	const channelOptions = CHANNEL_OPTIONS.map(type => {
		let label = type.charAt(0).toUpperCase() + type.slice(1);
		if (type === "wechat_public") {
			label = "Wechat";
		} else if (type === "twitter") {
			label = "Twitter/X";
		} else if (type === "onlineMedia") {
			label = "Online";
		} else if (type === "printMediaDmr") {
			label = "Print";
		}
		return { value: type, label };
	});

	const countryOptions = (countries || []).filter(optionA =>
		(countryMenu || []).some(item => optionA.id.toLowerCase() === item.key.toLowerCase())
	  ).map(option => ({ value: option.id, label: option.name }));	  

	return (
		<form id="filters" onSubmit={onSubmitClick}>
			<h6 className="card-subtitle text-muted mt-3 mb-3">
					Enter any term to search for voice and profile names, or use “profiles.id:xxxxx” to search by profile.id only.<br/>
					For searches in chinese language is better to enter the terms within quotation marks to get more accurate results.<br/>
					For URL searches, wrap the full URL in double quotes for accurate results, e.g. "https://www.instagram.com/james_sleaford".<br/>
			</h6>
			<Box styleProps={{ 
				display: 'flex',
				flexDirection: 'row',
				gap: 10,
				flexWrap: 'wrap',
			}}>
				<div className="input">
					<Input startIcon={<SearchOutline />} className="input" value={currentTerm} onChange={onChangeForm} placeholder="Enter term..."/>
				</div>
				{searchParams.term && (
					<>
						<div><GenericDropdownMenu field="type" menuName="Voice type" options={voiceOptions} onChange={onDropdownChange} selectedOption={searchParams.type} /></div>
						<div><GenericDropdownMenu field="channel" menuName="Channel" options={channelOptions} onChange={onDropdownChange} selectedOption={searchParams.channel} /></div>
						<div>
							{loadingCountries ? <Loader size={20} /> : (
								<GenericDropdownMenu 
									field="country" 
									menuName="Country" 
									options={countryOptions} 
									onChange={onDropdownChange} 
									selectedOption={searchParams.country} 
									key={JSON.stringify(countryOptions)}
								/>
							)}
						</div>
					</>
				)}
				<div>
					<Button
						type="submit"
						className="mr-1 mb-1"
						onClick={onSubmitClick}
						disabled={paginatedSearchLoading || loading || !currentTerm.length}
					>
						Submit
						{showLoader()}
					</Button>
				</div>
			</Box>
			{totalMatches > 0 && (
				<h4 className="page-subtitle pt-4">
					Total: {totalMatches}
				</h4>
			)}
		</form>

	)
}

VoiceSearchForm.propTypes = {
	paginatedSearchLoading: PropTypes.bool,
	onSubmit: PropTypes.func,
	term: PropTypes.string,
	onChange: PropTypes.func,
	loading: PropTypes.bool
}

export default VoiceSearchForm;
